import { Checkbox, Modal, TimePicker } from "antd";
import Select from 'react-select';
import { useEffect, useState } from "react";
import { getLabBackupInfo } from '../../api/api';
import Spinner from "../../components/_common/Spinner";
import { UpdateLabBackupInfo } from '../../redux/reducers/LabBackupInfoSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import { errorNotify } from "../../services/toast.notification";
import './style.css';
import { Dayjs } from "dayjs";

export interface InputProps {
  url: any
}

const LabBackupInfo = ({ url }: InputProps) => {

  const myStore = useAppSelector((state) => state)
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [type, setType] = useState("Full");
  const [weeklyShow, setWeeklyShow] = useState(false);
  const [ftime, setFirstTime] = useState<any>(undefined);
  const [ltime, setLastTime] = useState<any>(undefined);
  const [occuresOnAtTime, setOccuresOnAtTime] = useState<any>(undefined);
  const [occures, setOccures] = useState("OccuresOnAt");

  const occureList = [
    { label: 'روزانه', value: "Daily" },
    { label: 'هفتگی', value: "Weekly" },

  ];

  const [values, setValues] = useState({
    Prk_BackupSchedule_AutoID: 0,
    Frk_UserID: 0,
    Str_Type: "Full",
    Str_Name: "",
    Str_Ocuure: occureList[0],
    Bit_Saturday: false,
    Bit_Sunday: false,
    Bit_Monday: false,
    Bit_Tuesday: false,
    Bit_Wednesday: false,
    Bit_Thursday: false,
    Bit_Friday: false,
    Str_DBNames: "",
    Bit_OccuresOnAt: false,
    Str_OccuresOnAtTime: "",
    Bit_OccuresEvery: false,
    Str_OccuresEveryMinute: "",
    Str_StartAtTime: undefined,
    Str_FinishAtTime: undefined,
    Str_Description: "",
    Str_IISNetworkPath: "",
    Str_IISPath: "",
    Bit_Enabled: true
  });


  function onChangeValue(event: any) {
    setType(event.target.value);
    console.log(event.target.value);
  }


  const _getLabBackupInfo = (url: string) => {
    getLabBackupInfo(url)
      .then((result: any) => {
        let jsonResult = JSON.parse(result.data.json);
        dispatch(UpdateLabBackupInfo({
          CheckScheduleExist: jsonResult.CheckScheduleExist, Schedule: jsonResult.Schedule,
          AutoBackupSettings: jsonResult.AutoBackupSettings, CheckPath: jsonResult.CheckPath,
          BackupPath: jsonResult.BackupPath, CheckSMSService: jsonResult.CheckSMSService,
          CheckSMSServiceType: jsonResult.CheckSMSServiceType
        }))
        setIsLoading(false);
        //console.log('backup info is: '+ result.data.json);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })


  }

  useEffect(() => {

    _getLabBackupInfo(url);
  }, [])

  const ShowAddModal = () => {
    setAddModalOpen(true);
  }
  const handleOk = () => {
    setAddModalOpen(false);
  };

  const handleCancel = () => {
    setAddModalOpen(false);
  };

  function handleChange(event: any) {
    debugger;
    const { name, value } = event.target;

    if (name == "occures") {
      setOccures(value);
      if (value == "OccuresOnAt")
        setValues({ ...values, Bit_OccuresOnAt: true });
      else
        setValues({ ...values, Bit_OccuresEvery: true });

    }

    if (event.target.type == "checkbox") {
      setValues({ ...values, [name]: event.target.checked });
    }
    else
      setValues({ ...values, [name]: value });
  }

  const onChangeOccureList = (event: any) => {
    debugger;
    const { label, value } = event;

    if (value === "Weekly")
      setWeeklyShow(true);
    else
      setWeeklyShow(false);


    setValues((val: any) => ({
      ...val,
      Str_Ocuure: { label: label, value: value }
    }))

  }

  const onChangeFromTime = (time: Dayjs, timeString: string) => {
    debugger;
    setFirstTime(time);

    setValues((val: any) => ({
      ...val,
      Str_StartAtTime: timeString
    }))
  };

  const onChangeToTime = (time: Dayjs, timeString: string) => {
    setLastTime(time);
    setValues((val: any) => ({
      ...val,
      Str_FinishAtTime: timeString
    }))
  };

  const onChangeOccuresOnAtTime = (time: Dayjs, timeString: string) => {
    setOccuresOnAtTime(time);
    setValues((val: any) => ({
      ...val,
      Str_OccuresOnAtTime: timeString
    }))
  }

  return (
    <div className="tab-content-padding">

      <Modal style={{ direction: 'rtl' }} title="افزودن بکاپ" open={addModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} width={800}>

        <div className="row mb-2">
          <div onChange={(e) => handleChange(e)} style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
            <span style={{ display: 'flex', paddingLeft: '20px' }}><input type="radio" value="Full" name="Str_Type" checked={values.Str_Type === "Full"} /> Full</span>
            <span style={{ display: 'flex', paddingRight: '20px' }}><input type="radio" value="Differential" name="Str_Type" checked={values.Str_Type === "Differential"} /> Differential</span>
          </div>

          <div>

            <>
              <div className="row d-flex justify-content-around mt-3">
                <div className="borderd-content">
                  <div className="title">اطلاعات</div>
                  <div className="content" style={{ display: "flex", justifyContent: "space-between" }}>
                    <span >
                      <input
                        placeholder="نام پایگاه داده"
                        type="string"
                        autoComplete="false"
                        name="Str_DBNames"
                        id="Str_DBNames"
                        className="input-field"
                        onChange={(e) => handleChange(e)}
                        value={values.Str_DBNames}
                      />
                    </span>
                    <span>
                      <input
                        placeholder="نام"
                        type="string"
                        autoComplete="false"
                        name="Str_Name"
                        id="Str_Name"
                        className="input-field"
                        onChange={(e) => handleChange(e)}
                        value={values.Str_Name}
                      />
                    </span>
                    <span>
                      <Checkbox name="Bit_Enabled"
                        onChange={(e) => handleChange(e)}
                        value={values.Bit_Enabled} >فعال</Checkbox>
                    </span>
                    <span>
                      زمان رخداد:

                      <Select value={{ label: values.Str_Ocuure.label, value: values.Str_Ocuure.value }}
                        options={occureList}
                        onChange={(e) => onChangeOccureList(e)} />


                    </span>

                  </div>
                </div>
              </div>

              {weeklyShow === true && (
                <div className="row d-flex justify-content-around mt-3">
                  <div className="borderd-content">
                    <div className="title">روزهای هفته</div>
                    <div className="content" style={{ flex: 1, justifyContent: "space-between" }}>
                      <span> <Checkbox name="Bit_Saturday" onChange={(e) => handleChange(e)} value={values.Bit_Saturday}  >شنبه</Checkbox></span>
                      <span> <Checkbox name="Bit_Sunday" onChange={(e) => handleChange(e)} value={values.Bit_Sunday}>یکشنبه</Checkbox></span>
                      <span> <Checkbox name="Bit_Monday" onChange={(e) => handleChange(e)} value={values.Bit_Monday}>دوشنبه</Checkbox></span>
                      <span> <Checkbox name="Bit_Tuesday" onChange={(e) => handleChange(e)} value={values.Bit_Tuesday}>سه شنبه</Checkbox></span>
                      <span> <Checkbox name="Bit_Wednesday" onChange={(e) => handleChange(e)} value={values.Bit_Wednesday} >چهارشنبه</Checkbox></span>
                      <span> <Checkbox name="Bit_Thursday" onChange={(e) => handleChange(e)} value={values.Bit_Thursday}>پنجشنبه</Checkbox></span>
                      <span> <Checkbox name="Bit_Friday" onChange={(e) => handleChange(e)} value={values.Bit_Friday}>جمعه</Checkbox></span>
                    </div>
                  </div>
                </div>
              )
              }
              <div className="row d-flex justify-content-around mt-3">
                <div className="borderd-content">
                  <div className="title">رخدادها</div>

                  <div className="content">
                    <div className="row d-flex justify-content-around mt-3" onChange={(e) => handleChange(e)}>
                      <div className="col-md-6 d-flex flex-column">
                        <span style={{ display: 'flex', paddingLeft: '20px' }}><input type="radio" value="OccuresOnAt" name="occures" checked={occures === "OccuresOnAt"} /> Occures On At
                          <TimePicker disabled={occures === "OccuresEvery"} style={{ width: '120px' }} value={occuresOnAtTime} format={"hh:mm:ss"} onChange={(time: any, timeString: string) => onChangeOccuresOnAtTime(time, timeString)} />
                        </span>
                      </div>
                      <div className="col-md-6 d-flex flex-column">
                        <span style={{ display: 'flex', paddingRight: '20px' }}><input type="radio" value="OccuresEvery" name="occures" checked={occures === "OccuresEvery"} /> Occures Every
                          <input
                            disabled={occures === "OccuresOnAt"}
                            style={{ width: '50px', padding: '5px', margin: '0 10px' }}
                            placeholder="0"
                            type="string"
                            autoComplete="false"
                            name="Str_OccuresEveryMinute"
                            id="Str_OccuresEveryMinute"
                            onChange={(e) => handleChange(e)}
                            value={values.Str_OccuresEveryMinute}
                          />  دقیقه
                        </span>
                      </div>

                    </div>
                    <div className="row d-flex justify-content-around mt-3">
                      <div className="col-md-6 d-flex flex-column">
                      </div>
                      <div className="col-md-6">
                        <span style={{ paddingRight: '20px' }}>از</span>

                        <TimePicker disabled={occures === "OccuresOnAt"} style={{ width: '120px' }} value={ftime} format={"hh:mm:ss"} onChange={(time: any, timeString: string) => onChangeFromTime(time, timeString)} />
                        <span style={{ paddingRight: '20px' }}>تا</span>
                        <TimePicker disabled={occures === "OccuresOnAt"} style={{ width: '120px' }} value={ltime} format={"hh:mm:ss"} onChange={(time: any, timeString: string) => onChangeToTime(time, timeString)} />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-around mt-3">

                <div className="col-md-12">
                  <div className="borderd-content">
                    <div className="title">مسیر شبکه IIS </div>
                    <div className="content" style={{ display: "flex", justifyContent: "space-between" }}>
                      <input
                        placeholder="مسیر شبکه IIS"
                        type="string"
                        autoComplete="false"
                        name="Str_IISNetworkPath"
                        id="Str_IISNetworkPath"
                        onChange={(e) => handleChange(e)}
                        value={values.Str_IISNetworkPath}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-around mt-3">
                <div className="col-md-12">
                  <div className="borderd-content">
                    <div className="title">توضیحات</div>
                    <div className="content" style={{ display: "flex", justifyContent: "space-between" }}>
                      <input
                        placeholder="توضیحات"
                        type="string"
                        autoComplete="false"
                        name="Str_Description"
                        id="Str_Description"
                        onChange={(e) => handleChange(e)}
                        value={values.Str_Description}
                      />
                    </div>
                  </div>
                </div>

              </div>

            </>


          </div>
        </div>
      </Modal>


      {
        isLoading === false && (
          <div className="row">
            <div className={'d-flex justify-content-center gap-2'} onChange={onChangeValue} >
              <div className="form-check">
                <input className="form-check-input" id={'rdoFull'} type="radio" value="Full" name="Str_Type" checked={type === "Full"}/>
                <label className="form-check-label" htmlFor="rdoFull">Full</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" id={'rdoDifferential'} type="radio" value="Differential" name="Str_Type" checked={type === "Differential"}/>
                <label className="form-check-label" htmlFor="rdoDifferential">Differential</label>
              </div>
            </div>

            <div>
              {JSON.parse(JSON.stringify(myStore.backupInfo.Schedule)).map((item: any) =>
                //<p>{item.Str_Type}</p>
                item.Str_Type === type ? (
                  <>
                    <div className="row d-flex mt-3 row-gap-3">
                      <div className={'col-md-3'}>
                        <div className={'borderDashed'}>
                          <h5 className="card-header">اطلاعات</h5>
                          <div className="card-body">
                          <span className={'d-flex justify-content-between mb-2'}>
                            نام پایگاه داده:
                            <span>{item.Str_DbNames}</span>
                          </span>
                          <span className={'d-flex justify-content-between mb-2'}>
                            نام:
                            <span>{item.Str_Name}</span>
                          </span>
                          <span className={'d-flex justify-content-between mb-2'}>
                            <span>وضعیت:</span>
                            <Checkbox checked={item.Bit_Enabled} disabled >فعال</Checkbox>
                          </span>
                          <span className={'d-flex justify-content-between mb-2'}>
                            زمان رخداد:
                            <span>{item.Str_Ocuure}</span>
                          </span>
                          <span className={'d-flex justify-content-between mb-2'}>
                            نوع:
                            <span>{item.Str_Type}</span>
                          </span>

                        </div>
                        </div>
                      </div>
                      <div className={'col-md-3'}>
                        <div className="borderDashed">
                          <div className="card-header">روزهای هفته</div>
                          <div className="card-body">
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Saturday} disabled >شنبه</Checkbox></span>
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Sunday} disabled >یکشنبه</Checkbox></span>
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Monday} disabled >دوشنبه</Checkbox></span>
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Tuesday} disabled >سه شنبه</Checkbox></span>
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Wednesday} disabled >چهارشنبه</Checkbox></span>
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Thursday} disabled >پنجشنبه</Checkbox></span>
                            <span className={'d-flex'}> <Checkbox checked={item.Bit_Friday} disabled >جمعه</Checkbox></span>
                          </div>
                        </div>
                      </div>
                      <div className={'col-md-3'}>
                        <div className="borderDashed">
                          <div className="card-header">رخدادها</div>
                          <div className="card-body">
                            <span className={'d-flex justify-content-between mb-2'}>
                              وضعیت:
                              <Checkbox checked={item.Bit_OccuresOnAt} disabled >فعال</Checkbox>
                            </span>
                            <span className={'d-flex justify-content-between mb-2'}>
                              مدت زمان رخداد:
                              <span> هر {item.Str_OccuresEveryMinute} دقیقه</span>
                            </span>
                            <span className={'d-flex justify-content-between mb-2'}>
                              شروع:
                              <span>{item.StartAtTime}</span>
                            </span>
                            <span className={'d-flex justify-content-between mb-2'}>
                              پایان:
                              <span>{item.FinishAtTime}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="borderDashed">
                          <div className="card-header">توضیحات</div>
                          <div className="card-body">
                            <span>{item.Str_Description}</span>
                          </div>
                          <div className="card-header">مسیر شبکه IIS </div>
                          <div className="card-body">
                            <span>{item.Str_IISNetworkPath}</span>
                          </div>
                        </div>
                      </div>
                      <div className={'col-md-12'}>
                        <div className="d-flex justify-content-end gap-2">
                          <button className='ant-btn ant-btn-success' onClick={ShowAddModal} > افزودن</button>
                          <button className='ant-btn ant-btn-primary'> ویرایش</button>
                        </div>
                      </div>
                    </div>



                  </>
                ) : (<></>)
              )}
            </div>
          </div>
        )
      }
      {
        isLoading === true && (
          <Spinner />
        )
      }
    </div>

  )
}
export default LabBackupInfo;
